// @ts-check
/** @typedef {import('./types').Plan} Plan */
/** @typedef {import('./adapter/types.personal').ServerCurrentPlan} ServerCurrentPlanPersonal */
/** @typedef {import('./types').CurrentPlan} CurrentPlan */

import { addSeconds, addYears, formatDateJP, formatDateTime } from '@/libs/date.js';

/**
 * @param {Plan[]} plans
 * @param {ServerCurrentPlanPersonal} current
 * @returns {CurrentPlan}
 */
export const formCurrentPlan = (plans, current) => {
    const anYearAfterPeriodStart = addYears(current.current_period_starts_at, 1);
    return {
        ...plans.find((plan) => plan.id === current.plan_name),
        subscriptionId: current.id,
        appliedAt: current.registration_applied_at,
        periodStart: current.current_period_starts_at,
        periodEnd: formatDateTime(addSeconds(anYearAfterPeriodStart, -1)),
        renewalDateJP: formatDateJP(anYearAfterPeriodStart),
        scheduledPlanId: current.scheduled_plan_name,
        isAutoRenewed: current.subscription_ends_at == null,
        isDowngradeReserved: current.schedule_id != null,
        isInTrial: current.status === 'trialing',
    };
};

/**
 * @param {*} x
 * @returns {*} x
 */
export const identity = (x) => x;

/**
 * @param {DOMRect} tablePosition
 * @param {DOMRect} colPosition
 */
export const calculateOverlayLeft = (tablePosition, colPosition) => `${colPosition.left - tablePosition.left}px`;

/**
 * @param {DOMRect} colPosition
 */
export const calculateOverlaySize = (colPosition) => ({
    width: `${colPosition.width + 2}px`,
    height: `${colPosition.height}px`,
});
